import { Component, OnInit } from '@angular/core';
import { OperationService } from '../operation.service';
import { ProductStorageService } from '../../product_storages/product-storage.service';
import { Location } from '@angular/common';
import { Message } from 'primeng/primeng';
import { Router , ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

export interface Filter {
   name: any;
   sku: any;
 } 


@Component({
  selector: 'app-operation-items',
  templateUrl: './operation-items.component.html',
  styleUrls: ['./operation-items.component.css'],
  providers: [   
               OperationService,
               ProductStorageService
             ]
})
export class OperationItemsComponent implements OnInit {

   id: any = null;
   title: string = "Создать заявку";
   _searchGrid:boolean = false;
   productsForGrid: any=[];
   operationsCartGrid: any = [];
   loading:boolean =false;
   display:boolean = false;
   msgs: Message[] = [];
   operationCart: any[] = [];
   oparationItemCart: any[]=[];
   oparationItemCartVisible: boolean = false;
   oparationItemCartLoading: boolean = false;
   filter: Filter;
   textSku:any;
   textName: any;

   messageDisplay:boolean = false;
   deleteIndex: any;
   blocked:boolean = false;
   issueButtonDisabled:boolean = true;

   total: any;
   sumTotal: any=0;
   convertedSumTotal: any=0;

   operationItemSearchCartVisible: boolean = false;
   operationItemSearchCartLoading: boolean = false;
   operationItemSearchCart: any[] =[];


  constructor(
              private operationService: OperationService,
              private productStorageService: ProductStorageService,
              private _location: Location,
              private activatedRoute: ActivatedRoute,
              private router: Router
              ) {

                activatedRoute.params.subscribe(params=>{this.id=params['id']});
                console.log(this.id);
                if(this.id){
                  this.onLoad();
                }
     }

  ngOnInit() {
    this.calculateSumTotal();
  }


  
  onLoad(){
    console.log('onLoad');
    this.oparationItemCartLoading = true;
    if(localStorage.getItem('operations')){
      this.operationCart = JSON.parse(localStorage.getItem('operations'));
       if(JSON.parse(localStorage.getItem('operations'))[this.id]['items']){
           this.oparationItemCart = JSON.parse(localStorage.getItem('operations'))[this.id]['items'];
           this.oparationItemCart = this.oparationItemCart.map((value,index)=>{value.index= index; return value;})
       }
    }
    this.oparationItemCartLoading = false;
  }


  onRowSelect(event){


  } 

    addCart(data){

      if(!data.currency) {
        this.msgs=[];this.msgs.push({severity:'warn', summary:'Сообщение', detail: "В товаре "+data.product.name+" нет валюты!"});
            return false;
       }
      console.log(data);

      let tmpindex;


      for( let item in this.oparationItemCart){
          if(this.oparationItemCart[item].product.id==data.product.id){
            tmpindex = item;
          }
      }


      if(tmpindex){
          this.oparationItemCart[tmpindex].count =(+this.oparationItemCart[tmpindex].count)+(+1);
          this.oparationItemCart[tmpindex].total = this.oparationItemCart[tmpindex].count * data.retail_price;  
          this.oparationItemCart[tmpindex].total_converted_retail_price = this.oparationItemCart[tmpindex].count * data.converted_retail_price;  
      }else{
        this.oparationItemCart.push({
                              product: data.product,
                              currency: data.currency,  
                              retail_price: data.retail_price,
                              converted_retail_price: data.converted_retail_price,
                              store: data.store,
                              count: 1,
                              total: data.retail_price,
                              total_converted_retail_price: data.converted_retail_price,
                            });
      } 

      console.log(this.oparationItemCart);
      this.calculateSumTotal()  
      this.save();
      this.onLoad();
      this.operationItemSearchCartVisible=false;
      this.operationItemSearchCart=[];
      this.textSku = "";
      this.textName = "";


    }

    save(){
      console.log(this.oparationItemCart);
      this.oparationItemCartLoading = true;

      if(this.operationCart[this.id]){
          this.operationCart[this.id].sum_total = (+this.sumTotal).toFixed(2);
          this.operationCart[this.id]['items'] = this.oparationItemCart;        
      }
      localStorage.setItem('operations', JSON.stringify(this.operationCart));
      this.oparationItemCartLoading = false;
    }

    saveOnlyOperationCart(){
      this.oparationItemCartLoading = true;
      localStorage.setItem('operations', JSON.stringify(this.operationCart));
      this.oparationItemCartLoading = false;
    }



    delete(index: any){
      this.messageDisplay = true;
      this.deleteIndex = index;
    }

    OnAgreeDelete(){
      this.oparationItemCart.splice(this.deleteIndex,1);
      this.deleteIndex=null;
      this.messageDisplay = false;
      this.calculateSumTotal();
      this.save();
   }

   OnDegreeDelete(){
      this.messageDisplay = false;
   }

   calculateSumTotal(){
    this.sumTotal=this.oparationItemCart.reduce(function(sum: any, item: any) {return (+sum) + (+item.total);}, 0);
    this.sumTotal=this.sumTotal.toFixed(2);
    this.convertedSumTotal=this.oparationItemCart.reduce(function(sum: any, item: any) {return (+sum) + (+item.total_converted_retail_price);}, 0);
    this.convertedSumTotal=this.convertedSumTotal.toFixed(2);
  }

     loadOperationCartGrid(id: any):void{
		    // this.operationService.getOperationCartItemsByOperationId(id).subscribe(response=>{this.operationsCartGrid=response['data'];this.loading=false;});    	
    }

     deleteFromOperationCart(id: any):void{
      this.loading=true;
      this.operationService.deleteOperationItemService(id).subscribe(response=>{this.loading=false;this.loadOperationCartGrid(this.id);});	
    }

    showModal():void{
      this.display = true;
    }

     search(event,attribute) {
       this.operationItemSearchCart=[];
       this.operationItemSearchCartVisible=true;
       this.operationItemSearchCartLoading=true;
          this.productStorageService.getProductStorageByFilter([{name: attribute, value: event.query}],0,0,1).subscribe(response => {this.operationItemSearchCart=response['data'];this.operationItemSearchCartLoading = false;})
    }

    
    onSearchKeyUp(value){
      
      switch (value) {
        case 'sku':
           if(this.textSku.length<1){
                this.operationItemSearchCartVisible=false;
           }
        break;
      
        case 'name':
          if(this.textName.length<1){
              this.operationItemSearchCartVisible=false;
           }
        break;
      }
     
    }

    issue():void{
 console.log(this.id);
      let items = this.oparationItemCart.map(data=>{
                  return { 
                         product_id: data.product.id,
                         store_id: data.store.id,
                         price: data.retail_price,
                         count: data.count
                      }
                 });

      let data = {
        operation_type_id : '1',
        items: items
      };
      this.blocked = true;
      this.operationService.issueOperation(data).subscribe(response=>{this.operationCart.splice(this.id,1);
        this.saveOnlyOperationCart();
        this.router.navigate(['/dashboard/operation']);
      },(error)=>{
        this.blocked = false;
        this.display = false;
      });
    }

    backClicked() {
        this._location.back();
    }

    //  issue(form: NgForm):void{
    //   this.operationService.issueOperationInvoiceService(this.id,form.value).subscribe(response=>{console.log(response)});
    // }
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/operations/operation-items/operation-items.component.ts